export const initialState: any = {
  answers: {
    general: {
      mail: {
        mail: '',
        active: false,
        continueButton: true
      },
      consulting: {
        active: false,
        continueButton: true
      }
    },
    garden: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    balcony: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    houseplant: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    bonsai: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    agriculture: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    verticalGreening: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    sensors: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    },
    roofGreening: {
      q1: {},
      q2: {},
      q3: {},
      q4: {
        a2: {
          continueButton: false
        }
      }
    }
  },
  routes: {
    active: '',
    previous: ''
  },
  id: ''
};



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/store/main-state.ts